import { create } from 'zustand';
import { api } from '@/utils/api';

interface Workspace {
  id: number;
  name: string;
  slug: string;
  accent_color: string;
  icon: string | null;
  task_id_prefix: string;
  role?: string;
}

interface Project {
  id: number;
  workspace_id: number;
  name: string;
  slug: string;
  default_view: string;
  is_archived: number;
  sort_order: number;
}

interface WorkspaceState {
  workspaces: Workspace[];
  projects: Project[];
  loading: boolean;
  fetchWorkspaces: () => Promise<void>;
  fetchProjects: (workspaceId: number) => Promise<void>;
  createWorkspace: (name: string) => Promise<Workspace>;
  createProject: (workspaceId: number, name: string) => Promise<Project>;
}

export const useWorkspaceStore = create<WorkspaceState>((set) => ({
  workspaces: [],
  projects: [],
  loading: false,

  fetchWorkspaces: async () => {
    set({ loading: true });
    const data = await api.get<{ workspaces: Workspace[] }>('/workspaces');
    set({ workspaces: data.workspaces, loading: false });
  },

  fetchProjects: async (workspaceId) => {
    const data = await api.get<{ projects: Project[] }>(`/workspaces/${workspaceId}/projects`);
    set({ projects: data.projects });
  },

  createWorkspace: async (name) => {
    const data = await api.post<{ workspace: Workspace }>('/workspaces', { name });
    set((s) => ({ workspaces: [...s.workspaces, data.workspace] }));
    return data.workspace;
  },

  createProject: async (workspaceId, name) => {
    const data = await api.post<{ project: Project }>(`/workspaces/${workspaceId}/projects`, { name });
    set((s) => ({ projects: [...s.projects, data.project] }));
    return data.project;
  },
}));
